import Vue from 'vue'
import Router from 'vue-router'
import P1 from '@/components/P1'
import TestPage from '@/components/TestPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'P1',
      component: P1
    },
    {
      path: '/TestPage',
      name: 'TestPage',
      component: TestPage
    },
    {
      path: '/P1',
      name: 'P1',
      component: P1
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js